import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import API from '../../../api-graphql';
import { connect } from 'react-redux';
import TemplateCard from './TemplateCard';
import MessageCard from '../../UI/MessageCard';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography, LinearProgress, CircularProgress, Fab } from '@material-ui/core';
import { AddOutlined } from '@material-ui/icons';
import { styles } from './styles';
import { useTranslation } from 'react-i18next';
import SearchToolbar from '../../../components/SearchToolbar';
import { getTemplates } from '../../../actions';

// Tour
import { useTour } from '@reactour/tour';
import { tourSteps } from '../../TourSteps';

function TemplateListView (props) {
  const { setIsOpen, setCurrentStep, setSteps } = useTour();
  const {
    config: { subgroup },
    templates: { templates: configTemplates },
    filter: { templates: filterTemplate },
    getTemplates,
    classes
  } = props;
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState(props.filter.templates);
  const [templates, setTemplates] = useState([]);
  const [loadComplete, setLoadComplete] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [nextToken, setNextToken] = useState('');
  const [fetch, setFetch] = useState(null);
  const { t } = useTranslation();

  async function getTemplate () {
    const response = await getTemplates();
    if (response) setLoading(false);
  }

  useEffect(() => {
    const tour = JSON.parse(localStorage.getItem('tour-template'));
    setSteps(tourSteps.createNewTemplate);
    setCurrentStep(0);
    setIsOpen(tour);
  }, []);

  useEffect(() => {
    getTemplate();
  }, [filterTemplate]);

  useEffect(() => {
    if (fetch) {
      getListTemplates(filter, subgroup, nextToken);
    }
  }, [fetch]);

  function onScroll () { // eslint-disable-line 
    if (window.innerHeight + Math.round(document.documentElement.scrollTop) + 10 > document.documentElement.offsetHeight) {
      setFetch(true);
    }
  }

  const getListTemplates = (filter, subgroup, nextToken) => {
    setLoadingMore(true);

    API.listTemplates(filter, subgroup, nextToken).then((result) => {
      if (!result.data.listTemplates.nextToken) {
        setLoadComplete(true);
        setLoadingMore(false);
      } else {
        setLoadComplete(false);
        setLoadingMore(false);
      }
      if (nextToken) {
        setTemplates([...templates, ...result.data.listTemplates.items]);
        setNextToken(result.data.listTemplates.nextToken);
        setLoadingMore(false);
      } else {
        setTemplates(result.data.listTemplates.items);
        setNextToken(result.data.listTemplates.nextToken);
        setFilter(filter);
        setLoading(false);
      }
    })
      .catch((error) => {
        console.error('Error occurred while fetching document····················', error);
        setLoading(false);
      });
  };

  if (loading) {
    return <LinearProgress />;
  }

  return (
    <Grid container direction='column' className={classes.mainContainer}>
      <Grid container direction='column' item xs={12} md={10} >
        <Grid item className={classes.addBtn}>
          <Fab
            component={RouterLink}
            to='/template/new'
            color='primary'
            aria-label='Add'
            className={classes.btn}
          >
            <AddOutlined className='template-newTemplate' />
          </Fab>
          {t('templateList:newTemplate')}
        </Grid >
        <Grid item>
          <SearchToolbar visibleFor={['/template']} />
        </Grid>
      </Grid>
      {configTemplates.length > 0
        ? <>
          <Grid container direction='row' item xs={12} md={10} className={classes.containerCard}>
            {configTemplates.map((template) => (
              <TemplateCard getTemplates={getTemplates} key={template.id} template={template} />
            ))}
          </Grid>
          {loadingMore && (
            <div style={{ textAlign: 'center', marginTop: 16, marginBottom: 8 }}>
              <CircularProgress />
            </div>
          )}
          {loadComplete && (
            <div style={{ textAlign: 'center', marginTop: 16, marginBottom: 8 }}>
              <Typography>{t('templateList:noData')}</Typography>
            </div>
          )}
          </>
        : <MessageCard message={t('templateList:noTemplates')} url='#' />
      }
    </Grid>
  );
}

const mapStateToProps = (state) => {
  return {
    filter: state.filter,
    config: state.config,
    templates: state.templates
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTemplates: () => dispatch(getTemplates())
  };
};

TemplateListView.propTypes = {
  getTemplates: PropTypes.func.isRequired,
  templates: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(TemplateListView)
);
